import { cn } from "@/utils/utils";
import Image from "next/image";
import Link from "next/link";
import { ReactNode } from "react";

type FilterModalProps = {
  expandToolbar: boolean;
  onFilterIconClick: (e: any) => void;
  children: ReactNode[];
  onClearFiltersButton?: () => void;
  isDesktop: boolean;
  filterMessages: {
    clearButtonLabel: string;
    doneButtonLabel: string;
  };
};

export const FilterModal = ({
  expandToolbar,
  onFilterIconClick,
  children,
  onClearFiltersButton,
  isDesktop,
  filterMessages,
}: FilterModalProps) => {
  const { clearButtonLabel, doneButtonLabel } = filterMessages;

  return (
    <div id="filter-modal" className="w-full">
      <div
        onClick={(e) => e.stopPropagation()}
        className={cn(
          "fixed left-0 top-0 z-30 flex w-full basis-1/3 flex-col gap-4 bg-white p-8 shadow-filter-modal transition-transform ease-in-out sm:px-16",
          {
            "-translate-y-full": !expandToolbar,
            "translate-y-0": expandToolbar,
            hidden: isDesktop,
          }
        )}
      >
        <div className="flex flex-col gap-6">
          <figure className="flex w-full justify-center">
            <Link href={"/"}>
              <Image
                src="/logo-bi-mini.svg"
                alt="Business Immo Logo"
                width={40}
                height={32}
              />
            </Link>
          </figure>
          {children}
        </div>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClearFiltersButton}
            className="border-neutral-medium rounded-sm border px-2 py-1"
          >
            {clearButtonLabel}
          </button>
          <button
            onClick={onFilterIconClick}
            className="rounded-sm border border-primary bg-primary px-2 py-1 text-white"
          >
            {doneButtonLabel}
          </button>
        </div>
      </div>
      <div
        className={cn("hidden", {
          "bg-neutral-darker/50 fixed inset-0 z-20 flex h-full w-full justify-center":
            expandToolbar,
        })}
        onClick={onFilterIconClick}
      />
    </div>
  );
};
